export default ({ quoteColor, ...rest }) => (
  <svg
    width="39"
    height="25"
    viewBox="0 0 39 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    {...rest}
  >
    <path
      d="M1.18194 25C0.744186 25 0.415869 24.8894 0.19699 24.6681C-0.0218878 24.3732 -0.0583675 23.9676 0.0875513 23.4513L7.96717 1.10619C8.18605 0.368731 8.66028 0 9.38988 0H18.5828C19.6042 0 20.0055 0.479351 19.7866 1.43805L14.7524 23.7832C14.5335 24.5944 14.0593 25 13.3297 25H1.18194ZM20.5527 25C20.1149 25 19.7866 24.8894 19.5677 24.6681C19.3488 24.3732 19.3124 23.9676 19.4583 23.4513L27.2285 1.10619C27.4473 0.368731 27.9216 0 28.6512 0H37.8441C38.7925 0 39.1573 0.479351 38.9384 1.43805L34.1231 23.7832C33.9772 24.5944 33.503 25 32.7004 25H20.5527Z"
      fill={quoteColor === 'red' ? '#FA6A6B' : '#61C9D7'}
    />
  </svg>
)
